import { Box, Button, Stack } from "@sembark-travel/ui-base"
import { Dialog } from "@sembark-travel/ui-dialog"

/**
 * An image at full width and its natural height, with the caption sent with
 * it beneath. Open while `src` is set.
 */
export function WhatsAppImageDialog({
	src,
	alt,
	captionHtml,
	isNaturalSize = false,
	onClose,
}: {
	src: string | null
	alt: string
	/** The caption as the server rendered it, WhatsApp's formatting applied. */
	captionHtml: string | null
	/**
	 * Show the image at its own size, centred, rather than stretched to the
	 * dialog's width — for a sticker, which is drawn small.
	 */
	isNaturalSize?: boolean
	onClose: () => void
}) {
	return (
		<Dialog open={src !== null} onClose={onClose} title="Image" xl>
			<Dialog.Body>
				{src !== null ? (
					<Stack as="figure" gap="3" margin="0">
						<img
							src={src}
							alt={alt}
							style={
								isNaturalSize
									? {
											display: "block",
											maxWidth: "100%",
											height: "auto",
											margin: "0 auto",
										}
									: { display: "block", width: "100%", height: "auto" }
							}
						/>
						{captionHtml ? (
							<Box
								as="figcaption"
								whiteSpace="preserveLine"
								dangerouslySetInnerHTML={{ __html: captionHtml }}
							/>
						) : null}
					</Stack>
				) : null}
			</Dialog.Body>
			<Dialog.Footer>
				<Button onClick={onClose}>Close</Button>
			</Dialog.Footer>
		</Dialog>
	)
}
